export default __webpack_public_path__ + "static/media/price.b41b747e.svg";